import {Component, inject} from '@angular/core';
import {MatDialogActions, MatDialogRef, MatDialogTitle} from '@angular/material/dialog';
import {TranslocoPipe} from '@jsverse/transloco';
import {Store} from '@ngrx/store';
import {GlobalState} from '../../store/store.model';
import {logout} from '../../modules/authentication/store/authentication.actions';
import {App as CapacitorApp} from '@capacitor/app';
import {MatButton} from '@angular/material/button';

@Component({
  selector: 'app-exit-app',
  imports: [
    MatDialogActions,
    MatDialogTitle,
    TranslocoPipe,
    MatButton
  ],
  templateUrl: './exit-app.component.html',
  standalone: true,
  styleUrl: './exit-app.component.scss'
})
export class ExitAppComponent {
  private readonly _store = inject(Store<GlobalState>);

  constructor(private readonly _dialogRef: MatDialogRef<ExitAppComponent>) {}

  public cancel(): void {
    this._dialogRef.close(false);
  }

  public exit(): void {
    this._dialogRef.close(false);
    CapacitorApp.exitApp();
  }

  public logout(): void {
    this._dialogRef.close(false);
    this._store.dispatch(logout());
  }

}
